module.exports = __webpack_public_path__ + "static/PGP-e04686ac9329815dae8d5f7728d14d2b.jpg";